/**
    Layer service to be able to mock sessionStorage usage
*/

const sessionCache = {
    key: n => sessionStorage.key(n),

    setItem: (key, value) => sessionStorage.setItem(key, value),

    getItem: key => sessionStorage.getItem(key),

    removeItem: key => sessionStorage.removeItem(key),

    clear: () => sessionStorage.clear(),

    getLength: () => sessionStorage.length,
};

export default sessionCache;
